import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractPartialPayment } from '../AbstractPartialPayment';
import { InvoicePdfService } from '../../invoices/service/invoice-pdf.service';
import { PayableTableObject, PayableType } from '../../invoices/models/payable-table-object';
import { AssetUriService, ConfigService } from '@aiwyn/config';
import { ROUTE_TOKEN_ENGAGEMENTS_BASE, ROUTE_TOKEN_MAIN_BASE } from '../../../../routing-constants';
import { Store } from '@ngxs/store';
import { PaymentsState } from '@aiwyn/common/payments';

const DUE_UPON_RECEIPT = 'Due Upon Receipt';

@Component({
  selector: 'app-single-invoice-view',
  templateUrl: './single-invoice-view.component.html',
  styleUrls: ['./single-invoice-view.component.scss'],
  standalone: false,
})
export class SingleInvoiceViewComponent extends AbstractPartialPayment implements OnInit, OnDestroy {

  PayableType = PayableType;
  ROUTE_TOKEN_MAIN_BASE = ROUTE_TOKEN_MAIN_BASE;
  ROUTE_TOKEN_ENGAGEMENTS_BASE = ROUTE_TOKEN_ENGAGEMENTS_BASE;
  DUE_UPON_RECEIPT = DUE_UPON_RECEIPT;

  @ViewChild('payPartialInput')
  payPartialInput: ElementRef;

  @Input()
  invoiceTableDataObject: PayableTableObject

  amountOverdue: number;

  // should really only ever be one payable in this context but wanted to follow existing approach
  selectedPayables$ = this.store.select(PaymentsState.getSelectedPayables);

  constructor(
    public configService: ConfigService,
    public invoicePdfService: InvoicePdfService,
    public assetUriService: AssetUriService,
    protected store: Store,
  ) {
    super(configService, store);
  }

  ngOnInit(): void {
    // If user is moving from multi to single view with a partial payment, activate single invoice view partial payment
    const arTranAllocation = this.store.selectSnapshot(PaymentsState.getArTranAllocations)[0];
    if (arTranAllocation.allocatedAmount < this.invoiceTableDataObject.amountRemaining) {
      this.amountToPay = arTranAllocation.allocatedAmount;
      this.payPartialActive = true;
    }

    this.amountOverdue = this.getMaximumAmount(this.invoiceTableDataObject);
  }

  sendAnEmail(): void {
    console.log('sendAnEmail Called');
  }

  activatePayPartial(): void {
    this.payPartialActive = true;
    this.validate(this.invoiceTableDataObject);
    // TODO Get this working without a setTimeout.
    setTimeout(() => this.payPartialInput.nativeElement.focus(), 100);
  }

  /**
   * Unsubscribes from subjects when subscription is done being used.
   */
  ngOnDestroy(): void {
    super.onDestroy();
  }
}
